import { useIsPlant, useUserDomains } from '@/entities/user';
import { APP_PREFIX } from '@/shared/constants/app-prefix.constant';
import { USER_DOMAIN } from '@/shared/constants/user-domain.constant';

/**
 * Prefix of the user's only domain, otherwise based on isPlant
 */
export const useAppPrefix = (): string => {
	const isPlant = useIsPlant();
	const domains = useUserDomains();

	if (domains.length === 1) {
		return APP_PREFIX[domains[0]];
	}

	return APP_PREFIX[isPlant ? USER_DOMAIN.INDUSTRIAL : USER_DOMAIN.YACHTING];
};
